import { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";
import { DocRoot, PARTNER_DOC_TOPICS } from "@storyworm/portal-docs";
import { PD_DARK_THEME } from "@storyworm/ssup-ui";

/**
 * The partner-facing guide, rendered inside the portal. Content comes entirely
 * from the shared @storyworm/portal-docs package — the same topics the admin
 * console previews — so there is a single source of truth for what clients read.
 * Themed to the SSUP dark theme via the shared {@link PD_DARK_THEME}.
 */
export function PortalDocs({ onClose }: { onClose: () => void }) {
  const [topicId, setTopicId] = useState(PARTNER_DOC_TOPICS[0]?.id ?? "");
  const topic = PARTNER_DOC_TOPICS.find((t) => t.id === topicId) ?? PARTNER_DOC_TOPICS[0];
  const Body = topic?.Component;

  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      <Box
        component="aside"
        sx={{
          width: 300,
          flexShrink: 0,
          borderRight: "1px solid",
          borderColor: "divider",
          bgcolor: "background.paper",
          p: 2,
          height: "100vh",
          position: "sticky",
          top: 0,
          overflowY: "auto",
        }}
      >
        <Button startIcon={<ArrowBackIcon />} onClick={onClose} sx={{ mb: 1 }}>
          Back
        </Button>
        <List>
          {PARTNER_DOC_TOPICS.map((t) => (
            <ListItemButton
              key={t.id}
              selected={t.id === topic?.id}
              onClick={() => setTopicId(t.id)}
              sx={{ borderRadius: 2, mb: 0.5, alignItems: "flex-start" }}
            >
              <ListItemText
                primary={t.title}
                secondary={t.summary}
                primaryTypographyProps={{ fontWeight: 600 }}
              />
            </ListItemButton>
          ))}
        </List>
      </Box>

      <Box component="main" sx={{ flexGrow: 1, p: { xs: 3, md: 5 }, overflowX: "hidden" }}>
        <Box sx={{ maxWidth: 820, mx: "auto" }}>
          <DocRoot style={PD_DARK_THEME}>{Body ? <Body /> : null}</DocRoot>
        </Box>
      </Box>
    </Box>
  );
}
